import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Grid } from "@material-ui/core";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import CardMedia from "@material-ui/core/CardMedia";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Rating from "@material-ui/lab/Rating";
import Tooltip from "@material-ui/core/Tooltip";
import List from "@material-ui/core/List";
import Track from "./Track";

import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = (theme) => ({
  root: {
    width: "100%",
    boxShadow:
      "0px 2px 1px -1px rgba(0,0,0,0.5), 0px 1px 1px 0px rgba(0,0,0,0.38), 0px 1px 3px 0px rgba(0,0,0,0.34)",
  },
  ratingComplete: {
    "& .MuiRating-iconFilled": {
      color: theme.palette.primary.dark,
    },
  },
  ratingIncomplete: {
    "& .MuiRating-iconFilled": {
      color: theme.palette.action.selected,
    },
    "& .MuiRating-iconEmpty": {
      color: theme.palette.action.hover,
    },
  },
  spanning: {
    width: "100%",
  },
  cover: {
    width: "100%",
    height: "100%",
    backgroundSize: "contain",
    opacity: 0.85,
  },
});

class AlbumAccordion extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false };
  }

  openOrCloseAccordion = () => {
    const { onOpen, trackAndAlbumInfo, hasLoadedTracks } = this.props;
    const { isOpen } = this.state;

    this.setState((prevState) => {
      return {
        isOpen: !prevState.isOpen,
      };
    });

    if (!isOpen && !hasLoadedTracks) {
      onOpen(trackAndAlbumInfo.albumID);
    }
  };

  render() {
    const {
      classes,
      onTrackRated,
      onTagsUpdatedOptimistic,
      hasLoadedTracks,
      trackAndAlbumInfo,
      store,
    } = this.props;

    const { isOpen } = this.state;

    return (
      <Accordion
        className={classes.root}
        expanded={isOpen}
        onChange={this.openOrCloseAccordion}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Grid container>
            <Grid container item xs={12} justify={"space-between"} spacing={1}>
              <Grid container item xs={1} justify="center" direction="column">
                <CardMedia
                  className={classes.cover}
                  image={trackAndAlbumInfo.albumArtURL}
                  title={trackAndAlbumInfo.albumName + " album cover"}
                />
              </Grid>
              <Grid container item xs={7} justify="center" direction="column">
                <Typography variant={"h6"} color={"textSecondary"}>
                  {trackAndAlbumInfo.albumName}
                </Typography>
                <Typography variant={"caption"} color={"textSecondary"}>
                  {trackAndAlbumInfo.albumArtists}
                </Typography>
              </Grid>
              <Grid container item xs={4} justify={"space-between"}>
                <Tooltip
                  title={
                    trackAndAlbumInfo.averageScore +
                    " points" +
                    (trackAndAlbumInfo.albumTotalTracksRated ===
                    trackAndAlbumInfo.albumTotalTracks
                      ? ""
                      : " (provisional)")
                  }
                >
                  <Grid
                    container
                    item
                    xs={6}
                    justify="center"
                    direction="column"
                  >
                    <Rating
                      value={trackAndAlbumInfo.albumRating}
                      precision={0.5}
                      size={"small"}
                      className={
                        trackAndAlbumInfo.albumTotalTracksRated ===
                        trackAndAlbumInfo.albumTotalTracks
                          ? classes.ratingComplete
                          : classes.ratingIncomplete
                      }
                      readOnly
                    />
                  </Grid>
                </Tooltip>
                <Grid container item xs={6} justify="center" direction="column">
                  <Typography
                    variant="overline"
                    color={
                      trackAndAlbumInfo.albumTotalTracksRated ===
                      trackAndAlbumInfo.albumTotalTracks
                        ? "primary"
                        : "error"
                    }
                  >
                    {trackAndAlbumInfo.albumTotalTracksRated}/
                    {trackAndAlbumInfo.albumTotalTracks} rated
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          {!hasLoadedTracks ? (
            <Grid container item xs={12} justify="center">
              <CircularProgress />
            </Grid>
          ) : (
            <List className={classes.spanning}>
              {trackAndAlbumInfo.tracks.map((track, i) => (
                <Track
                  key={track.id}
                  trackAndAlbumInfo={{
                    albumArtists: trackAndAlbumInfo.albumArtists,
                    albumArtURL: trackAndAlbumInfo.albumArtURL,
                    albumID: trackAndAlbumInfo.albumID,
                    albumIndex: trackAndAlbumInfo.albumIndex,
                    albumName: trackAndAlbumInfo.albumName,
                    albumTotalTracks: trackAndAlbumInfo.albumTotalTracks,
                    artistName: track.artistName,
                    rating: track.rating,
                    releaseYear: trackAndAlbumInfo.releaseYear,
                    tags: track.tags,
                    trackID: track.id,
                    trackName: track.name,
                    trackIndex: track.index,
                    trackNumber: track.trackNumber,
                    trackLength: track.trackLength,
                  }}
                  onTagsUpdatedOptimistic={onTagsUpdatedOptimistic}
                  onTrackRated={onTrackRated}
                  store={store}
                  trackIDsAfter={trackAndAlbumInfo.tracks
                    .slice(i + 1)
                    .map((track) => track.id)}
                  tabIndex={i + 1}
                />
              ))}
            </List>
          )}
        </AccordionDetails>
      </Accordion>
    );
  }
}

export default withStyles(useStyles)(AlbumAccordion);
